<template>
  <DropdownMenu v-model:open="isSettingsOpen">
    <DropdownMenuTrigger>
      <Tooltip side="bottom" :side-offset="8" :delay-duration="400">
        <span
          :class="
            cn(
              'text-accent-400 hover:bg-neutral-50/[0.12] py-2 px-3 inline-flex',
              isSettingsOpen && 'bg-neutral-50/[0.12]'
            )
          "
        >
          <Settings class="size-6" />
        </span>

        <template #content>
          <p>Project settings</p>
        </template>
      </Tooltip>
    </DropdownMenuTrigger>
    <DropdownMenuContent :align="'center'" class="w-44">
      <DropdownMenuItem class="justify-between" @select="toggleGrid">
        <span>Show grid</span>
        <Check v-if="grid.show" class="size-4 text-accent-400" />
      </DropdownMenuItem>
      <DropdownMenuItem class="justify-between" @select="snapToGrid">
        <span>Snap to grid</span>
        <Check v-if="grid.snap" class="size-4 text-accent-400" />
      </DropdownMenuItem>
      <DropdownMenuItem class="justify-between" @select="toggleSpellCheck">
        <span>Spell checking</span>
        <Check v-if="spellcheck.show" class="size-4 text-accent-400" />
      </DropdownMenuItem>
      <DropdownMenuItem class="justify-between" @select="onPointerDeviceToggle">
        <span>Input device</span>
        <div class="text-sm text-center">
          <template v-if="pointerDeviceAutoDetect">
            <div>Auto</div>
          </template>
          <small class="text-neutral-500">{{ pointerDeviceMode }}</small>
        </div>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { Settings, Check } from 'lucide-vue-next';
import { cn } from '@ui/utils';
import { Tooltip } from '@ui/components/tooltip';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@ui/components/dropdown-menu';
import { DEVICE_MODE } from '@/lib/pointerDeviceDetector.js';

const store = useStore();

const isSettingsOpen = ref(false);

const grid = computed(() => store.getters['project/config/getGrid']);
const spellcheck = computed(
  () => store.getters['project/config/getSpellcheck']
);
const pointerDeviceAutoDetect = computed(
  () => store.getters['application/getPointerDeviceAutoDetect']
);
const pointerDeviceMode = computed(
  () => store.getters['application/getPointerDeviceMode']
);

const toggleGrid = e => {
  e.preventDefault();
  store.dispatch('project/config/setGrid', {
    props: { show: !grid.value.show },
    apply: true,
  });
};

const snapToGrid = e => {
  e.preventDefault();
  store.dispatch('project/config/setGrid', {
    props: { snap: !grid.value.snap },
    apply: true,
  });
};

const toggleSpellCheck = e => {
  e.preventDefault();
  store.dispatch('project/config/setSpellcheck', {
    props: { show: !spellcheck.value.show },
    apply: true,
  });
};

const onPointerDeviceToggle = e => {
  e.preventDefault();
  if (pointerDeviceAutoDetect.value) {
    store.dispatch('application/setPointerDeviceAutoDetect', { value: false });
    store.dispatch('application/setPointerDeviceMode', {
      value: DEVICE_MODE.MOUSE,
    });
  } else if (pointerDeviceMode.value === DEVICE_MODE.MOUSE) {
    store.dispatch('application/setPointerDeviceMode', {
      value: DEVICE_MODE.TOUCHPAD,
    });
  } else {
    store.dispatch('application/setPointerDeviceAutoDetect', { value: true });
    store.dispatch('application/setPointerDeviceMode', {
      value: DEVICE_MODE.MOUSE,
    });
  }
};
</script>
